<script lang="ts">
  import { tooltip } from "$lib/tooltip/tootlip.svelte";
  import type { Snippet } from "svelte";

  interface Props {
    checked: boolean;
    children?: Snippet;
    label?: string;
    onchange?: (checked: boolean) => void;
  }

  let {
    checked = $bindable(false),
    children,
    onchange,
    label,
  }: Props = $props();

  function toggle(e: Event) {
    e.preventDefault();
    checked = !checked;
    onchange?.(checked);
  }
</script>

<button
  class="icon-toggle icon-button"
  type="button"
  onclick={toggle}
  class:checked
  use:tooltip={label}
  aria-label={label || undefined}
>
  {@render children?.()}
</button>

<style lang="scss">
  @use "@astlai/common/styles/mixins" as lib;
  .icon-toggle {
    color: var(--text-secondary);
    &.checked {
      color: var(--accent60);
    }
  }
</style>
